import React from 'react';
import { generatePath } from 'react-router-dom';
import RouterLink from '@/components/common/RouterLink';
import TimeValue from '@/components/common/TimeValue';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import { DONATION_VOLUNTEER_CONFIG } from '@/lib/configs/contributions';
import translate from '@/lib/intl/translate';
import getEntitySource from '../lib/getEntitySource';
import EntityDate from './EntityDate';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
export default function TimeDonationSummary({ entity }: any) {
  const {
    campaignDisplayName,
    campaignId,
    constituents: [{ constituentId, displayName }],
    donationDateString,
    donationId,
    timeData: { time, timeCategory, timeUnit, timeValue },
  } = entity;

  const translation = campaignDisplayName
    ? 'CONTRIBUTION_ENTITY_SUMMARY_TIME_FOR_CAMPAIGN'
    : 'CONTRIBUTION_ENTITY_SUMMARY_TIME';

  const category = DONATION_VOLUNTEER_CONFIG.find(
    ({ enum: categoryEnum }) => categoryEnum === timeCategory,
  );

  return translate(translation, {
    constituentLink: (
      <RouterLink to={generatePath(AuthRoutes.CONSTITUENT, { constituentId })}>
        {displayName}
      </RouterLink>
    ),
    time,
    timeUnit,
    timeValue: <TimeValue value={String(timeValue)} />,
    category: category ? (
      <>
        <img className="inline" alt={category.iconAlt} src={category.icon} />
        {category.text}
      </>
    ) : null,
    date: <EntityDate entityId={donationId} dateString={donationDateString} />,
    ...(campaignDisplayName && {
      campaignLink: (
        <RouterLink to={generatePath(AuthRoutes.CAMPAIGN, { campaignId })}>
          {campaignDisplayName}
        </RouterLink>
      ),
    }),
    ...getEntitySource(entity),
  });
}
